__turbopack_context__.v({
  "Layout": "styles-module__S1RmGa__Layout",
});
